<template>
    <div class="w-full h-full flex flex-col p-6 lg:p-10 bg-gray-100">
        <Loading v-show="loading" :loading="loading" />
        <div class="w-full h-full">
            <div class="w-full flex flex-row justify-between items-center mb-5 ">
                <h1 class="text-theme-primary text-3xl font-semibold">Profile</h1>
                <div @click="goToEditProfile()"
                    class="flex flex-row gap-2 bg-theme-primaryLight hover:bg-green-100 cursor-pointer items-center px-3 py-2 rounded-full text-theme-primary font-medium">
                    <img src="@/assets/images/papsi_edit_icon.svg" class="w-4 h-4" />
                    <p class="hidden lg:block">Edit Profile</p>

                </div>
            </div>



            <div class="grid grid-cols-1 lg:grid-cols-7 w-full gap-10">

                <!-- First Column: QR -->
                <div
                    class="col-span-1 lg:col-span-2 bg-white rounded-2xl shadow-sm mb-auto justify-center items-start p-4 lg:p-7 w-full">
                    <div class="">
                        <div class="w-full flex flex-col justify-center items-center">
                            <!-- <img :src="getQr()" width="220" /> -->
                             <qrcode-vue
                                :value="qr"
                                :size="200"
                                level="M"
                                class="my-4"
                            />
                            <button
                                class="px-3 py-1 bg-theme-secondary font-medium rounded-full hover:cursor-pointer mt-2"
                                @click="downloadQR">
                                Download QR
                            </button>
                        </div>
                        <p class="w-full text-2xl text-gray-600 font-semibold mt-5 mb-3 text-center">{{ full_name }}</p>
                        <!-- <p class="w-full text-sm text-gray-500 font-medium mb-5 text-center">{{ username }}</p> -->
                        <div class="grid grid-cols-2 gap-3 rounded-xl bg-gray-50 py-5">

                            <div class="flex flex-col space-y-1 w-full justify-center text-center">
                                <p class="text-gray-400 text-sm">Account No.</p>
                                <p class="text-xl font-medium">{{ account_number }}</p>
                            </div>
                            <div class="flex flex-col space-y-1 w-full justify-center text-center">
                                <p class="text-gray-400 text-sm">Serial No.</p>
                                <p class="text-xl font-medium">{{ serial }}</p>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- Second Column: Account Info -->
                <div
                    class="col-span-1 lg:col-span-5 bg-white rounded-2xl shadow-sm mb-auto justify-center items-start p-4 lg:p-7 w-full">
                    <p class="px-3 py-1 text-gray-600 font-medium text-lg border-l-8 border-theme-secondary">
                        Member Information</p>
                    <div class="grid col-span-1 lg:grid-cols-2 gap-2 lg:gap-5 mt-2">
                        <div class="flex flex-col space-y-1">
                            <p>Gender</p>
                            <p class="bg-gray-100 px-4 py-3 rounded-lg truncate h-12">{{ gender }}</p>
                        </div>
                        <div class="flex flex-col space-y-1">
                            <p>TIN</p>
                            <p class="bg-gray-100 px-4 py-3 rounded-lg truncate h-12">{{ tin }}</p>
                        </div>
                        <div class="flex flex-col space-y-1">
                            <p>Birthdate</p>
                            <p class="bg-gray-100 px-4 py-3 rounded-lg truncate h-12">{{ birthdate }}</p>
                        </div>
                        <div class="flex flex-col space-y-1">
                            <p>Age</p>
                            <p class="bg-gray-100 px-4 py-3 rounded-lg truncate h-12">{{ age }}</p>
                        </div>
                        <div class="flex flex-col space-y-1">
                            <p>Membership Type</p>
                            <p class="bg-gray-100 px-4 py-3 rounded-lg h-12">{{ Membership }}</p>
                        </div>
                        <div class="flex flex-col space-y-1">
                            <p>Registered Date</p>
                            <p class="bg-gray-100 px-4 py-3 rounded-lg h-12">{{ registered }}</p>
                        </div>
                    </div>


                    <p class="px-3 py-1 text-gray-600 font-medium text-lg border-l-8 border-theme-secondary mt-10">
                        Contact Information</p>
                    <div class="grid grid-cols-1 lg:grid-cols-2 gap-3 lg:gap-5 mt-2">
                        <div class="flex flex-col space-y-1">
                            <p>Mobile Number</p>
                            <div class="flex justify-between items-center bg-gray-100 px-4 py-3 rounded-lg truncate h-12">
                                <p class="truncate">{{ maskMobile(mobile) }}</p>
                                <!-- <img src="@/assets/images/papsi_edit_icon_gray.svg" class="w-4 h-4 cursor-pointer" @click="goToEditMobile()"/> -->
                            </div>
                        </div>
                        <div class="flex flex-col space-y-1">
                            <p>Email Address</p>
                            <div class="flex justify-between items-center bg-gray-100 px-4 py-3 rounded-lg truncate h-12">
                                <p class="truncate">{{ email }}</p>
                                <!-- <img src="@/assets/images/papsi_edit_icon_gray.svg" class="w-4 h-4 cursor-pointer" @click="goToEditEmail()"/> -->
                            </div>
                        </div>
                    </div>



                </div>


            </div>

            <ModalControl v-show="this.show_update" v-bind:display="this.show_update" @positiveClick="directSettings"
                :positiveButton="'Update'" :default_width="'max-w-lg'" id='show_update'
                v-bind="(!($store.state.credentials.mobile && $store.state.credentials.email)) ? {} : { negativeButton: 'Skip', onNegativeClick: skip }">
                <div class="pt-6">
                    <h2 class="text-xl lg:text-2xl font-bold text-theme-primary mb-2 text-left">Update your Information
                    </h2>
                    <p class="mb-4 lg:mb-5 text-left text-base">Upon checking our records, we noticed some of your
                        information is missing. Please update your details to keep your account complete and up-to-date.
                    </p>
                </div>

                <div class="flex flex-col text-gray-500 text-left w-full text-base justify-center items-center gap-3 mb-4">
                    <div class="w-full flex flex-row gap-3 justify-between items-center bg-red-100 border-2 border-red-700 text-red-700 rounded-xl p-3"
                    v-show="!$store.state.credentials.email">
                    <p>Email Address</p>
                    </div>
                    <div class="w-full flex flex-row gap-3 justify-between items-center bg-red-100 border-2 border-red-700 text-red-700 rounded-xl p-3"
                    v-show="!$store.state.credentials.mobile">
                    <p>Mobile Number</p>
                    
                    </div>
                    <div class="w-full flex flex-row gap-3 justify-between items-center bg-red-100 border-2 border-red-700 text-red-700 rounded-xl p-3"
                    v-show="!$store.state.credentials.birthdate">
                    <p>Birthdate</p>
                    
                    </div>

                    <div class="w-full flex flex-row gap-3 justify-between items-center bg-red-100 border-2 border-red-700 text-red-700 rounded-xl p-3"
                    v-show="!$store.state.credentials.tin">
                    <p>Taxpayer Identification Number (TIN)</p>
                    
                    </div>
                </div>
            </ModalControl>

            <ModalControl v-show="this.show_message_modal" :display="this.show_message_modal" :error="this.error"
                :success="this.success" :modal_message="'test'" :question="this.warning" @positiveClick="submit"
                :positiveButton="this.success ? 'OK' : this.error ? null : 'YES'" @negativeClick="handleNegativeClick()"
                :negativeButton="this.error ? 'OK' : this.success ? null : 'NO'" z_value="z-50"
                :default_width="'max-w-lg'" id="vote_modal">
                <div
                    class="w-full p-5 pt-2 flex flex-col text-gray-500 text-lg justify-center text-center items-center">
                    {{ this.modal_message }}
                </div>
            </ModalControl>




        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
import Loading from '@/components/controls/LoadingControl.vue';
import ModalControl from '@/components/controls/ModalControl.vue';
import QrcodeVue from 'qrcode.vue'
import User from "@/services/User";
import OTP from "@/services/OTP";
import axios from 'axios'

export default defineComponent({
    components: {
        Loading,
        ModalControl,
        QrcodeVue
    },
    inject: ['setLoading'],
    data() {
        return {
            account_number: '',
            qrLoading: true,
            full_name: '',
            gender: '',
            birthdate: '',
            age: '',
            Astatus: '',
            show_update: false,
            Membership: '',
            Member_since: '',
            email: '',
            mobile: '',
            tin: '',
            qr: '',
            serial: '',
            username: '',
            loading: false,
            registered: '',
            expired: false,
            error: false,
            success: false,
            warning: false,
            modal_message: '',
            show_message_modal: false,
            activeTab: 'member'
        }
    },
    mounted() {
        let that = this;
        const state = this.$store.state;
        that.account_number = state.credentials.account_no;
        that.full_name = state.credentials.name;
        that.gender = state.credentials.gender;
        that.Astatus = state.credentials.status;
        that.Membership = state.credentials.membership_type;
        that.Member_since = state.credentials.membership_date;
        that.email = state.credentials.email;
        that.mobile = state.credentials.mobile;
        that.tin = state.credentials.tin;
        that.age = state.credentials.age;
        that.birthdate = state.credentials.birthdate;
        that.serial = state.credentials.serial_no == null ? '??????' : state.credentials.serial_no;
        that.username = state.credentials.username;
        that.registered = state.credentials.registered_date;
        that.qr = state.credentials.qr;
        that.currentTin = state.credentials.tin;
 

        const rawRegisteredDate = state.credentials.registered_date;
        if (rawRegisteredDate) {
            const parts = rawRegisteredDate.split('-');
            that.registered = `${parts[1]}/${parts[2]}/${parts[0]}`;
        }

        const rawBirthdate = state.credentials.birthdate;
        if (rawBirthdate) {
            const parts = rawBirthdate.split('-');
            that.birthdate = `${parts[1]}/${parts[2]}/${parts[0]}`;
        }

        if (!state.credentials.username) {
            this.getUserInfo();
        } else {
            this.checkUserFlow();
        }

    },
    methods: {
        handleNegativeClick() {
            if (this.expired) {
                this.closed();
            } else {
                this.closed_modal();
            }
        },
        closed() {
            let that = this;

            that.$cookies.remove('user');
            that.$cookies.remove('user_session');
            that.$router.push('/');
            that.show_message_modal = false;
        },
        goToEditProfile() {
            // this.$store.state.clickedEdit = 'username';
            this.$router.push('/user/settings');
        },
        // goToEditMobile() {
        //     this.$store.state.clickedEdit = 'mobile';
        //     this.$router.push('/user/settings');
        // },
        // goToEditEmail() {
        //     this.$store.state.clickedEdit = 'email';
        //     this.$router.push('/user/settings');
        // },
        checkUserFlow() {
            const that = this;
            const state = that.$store.state;
            const noContact = !state.credentials.mobile || !state.credentials.email;
            const config = state.credentials.config;
            const temporaryPIN = state.credentials.pin_update;
            const isValidated = that.$cookies.get('validated');

            if (state.credentials.deactivated) {
                this.$router.push('/user/settings');
                return;
            }

            if (noContact) {
                state.credentials.noContact = noContact;
                this.show_update = true;
                return;
            }

            if (state.credentials.enrolled_pin) {
                const hasValidConfig = config && config.status;
                const noContact = state.credentials.noContact;
                state.credentials.enrolled_pin = false;

                if (noContact) {
                that.show_update = false;
                that.show_pin_modal = false;
                that.show_otp_modal = false;
                that.$cookies.set('validated', true);
                } else {
                if (hasValidConfig) {
                    that.requestOTP();
                } else {
                    that.show_update = false;
                    that.show_pin_modal = false;
                    that.show_otp_modal = false;
                    that.$cookies.set('validated', true);
                }
                }
                return;
            }


            if (!isValidated) {
                if (state.credentials.has_pin) {
                    this.show_pin_modal = true;
                } else {
                    this.$router.push('/user/settings');
                }
            }

            if (temporaryPIN) {
                this.$router.push('/user/settings');
                state.credentials.edit_temporary = true;
                return;
            }

            const missingInfo = !state.credentials.mobile || !state.credentials.email ||
                                !state.credentials.tin || !state.credentials.birthdate;

            if (missingInfo && !that.$cookies.get('skipped')) {
                this.show_update = true;
            }
            },
        getUserInfo() {
            let that = this;
            const cookie = that.$cookies;
            const store = that.$store;
            let state = store.state;
            that.setLoading(true);

            User.recoverSession(cookie.get('user_session').hash).then(function (response) {
                let data = response.data.data;
                state.logged = true;
                state.credentials.first_name = data.info.first_name;
                state.credentials.last_name = data.info.last_name;
                state.credentials.middle_name = data.info.middle_name;
                state.credentials.regular = data.info.regular;
                state.credentials.express = data.express;
                state.credentials.pso_enroll = data.pso_enroll;
                state.credentials.pin_update = data.pin_update;
                state.credentials.membership_date = data.info.membership_date || null;
                state.credentials.status = data.status || null;
                state.credentials.account_no = data.info.account_number;
                state.credentials.email = data.info.email;
                state.credentials.gender = data.info.gender;
                state.credentials.birthdate = data.info.date_of_birth;
                state.credentials.age = data.info.age;
                state.credentials.membership_type = data.info.membership_type;
                state.credentials.registered_date = data.info.registered;
                state.credentials.key = data.key;
                state.gaUser = data.ga;
                state.credentials.mobile = data.info.mobile;
                state.credentials.name = data.info.first_name + " " + data.info.last_name + (data.info.suffix ? " " + data.info.suffix : "");
                state.credentials.suffix = data.info.suffix ?? '';
                state.credentials.qr = data.qr;
                state.credentials.uuid = data.uuid;
                state.credentials.serial_no = data.info.serial_number;
                state.credentials.timestamp = response.timestamp;
                state.credentials.username = data.info.username;
                state.credentials.hash = data.hash;
                state.credentials.has_pin = data.has_pin;
                state.credentials.deactivated = data.deactivated;
                state.credentials.tin = data.info.tin;
                const type2Config = data.config.find(item => item.type === 2);
                if (type2Config) {
                    state.credentials.config = { status: type2Config.status };
                } else {
                    state.credentials.config = null;
                }
                that.account_number = state.credentials.account_no;
                that.full_name = state.credentials.name;
                that.gender = state.credentials.gender;
                that.Astatus = state.credentials.status;
                that.Membership = state.credentials.membership_type;
                that.Member_since = state.credentials.membership_date;
                that.email = state.credentials.email;
                that.mobile = state.credentials.mobile;
                that.tin = state.credentials.tin;
                that.age = state.credentials.age;
                that.birthdate = state.credentials.birthdate;
                that.serial = state.credentials.serial_no == null ? '??????' : state.credentials.serial_no;
                that.username = state.credentials.username;
                that.registered = state.credentials.registered_date;
                that.qr = data.qr;
                that.currentTin = state.credentials.tin;
                that.express = data.express;
                that.deactivated = data.deactivated;
                const rawRegisteredDate = state.credentials.registered_date;
                if (rawRegisteredDate) {
                    const parts = rawRegisteredDate.split('-');
                    that.registered = `${parts[1]}/${parts[2]}/${parts[0]}`;
                }

                const rawBirthdate = state.credentials.birthdate;
                if (rawBirthdate) {
                    const parts = rawBirthdate.split('-');
                    that.birthdate = `${parts[1]}/${parts[2]}/${parts[0]}`;
                }

                that.checkUserFlow();
                that.setLoading(false);

            }).catch(function (error) {
                that.error = true;
                that.setLoading(false);
                that.show_message_modal = true;
                that.modal_message = error.response.data.message;
                if (error.response.status == 403) {
                    that.expired = true
                    that.modal_message = "Your session has expired. Please log in again.";
                    that.$store.state.logged = false;
                }
            });
        },
        skip() {
            this.show_update = false;
            this.$cookies.set('skipped', true);
        },
        directSettings() {
            this.show_update = false;
            this.$router.push({ name: 'settings' });
            this.$cookies.set('skipped', true);
        },
        maskMobile(mobile) {
            if (!mobile) return '';
            const digits = mobile.replace(/\D/g, '');
            if (digits.length === 10) {
                return `(0${digits.slice(0, 3)}) ${digits.slice(3, 6)} ${digits.slice(6)}`;
            }
            if (digits.length === 11 && digits.startsWith('0')) {
                return `(${digits.slice(0, 4)}) ${digits.slice(4, 7)} ${digits.slice(7)}`;
            }
            if (digits.length === 12 && digits.startsWith('63')) {
                return `(0${digits.slice(2, 5)}) ${digits.slice(5, 8)} ${digits.slice(8)}`;
            }
            return mobile;
        },
        testHash() {
            let that = this;
            const cookie = that.$cookies;
            const store = that.$store;
            let state = store.state;
            this.setLoading(true);
            // console.log(cookie.get('user').hash);
            User.recoverSession(cookie.get('user_session').hash).then(function (response) {
                let data = response.data.data;
                state.logged = true;
                state.validated = true;
                state.credentials.account_no = data.info.account_number;
                state.credentials.serial_no = data.info.serial_number;
                state.credentials.email = data.info.email;
                state.credentials.birthdate = data.info.date_of_birth;
                state.credentials.age = data.info.age;
                state.gaUser = data.ga;
                state.credentials.membership_type = data.info.membership_type;
                state.credentials.registered_date = data.info.registered;
                state.credentials.key = data.key;
                state.credentials.mobile = data.info.mobile;
                state.credentials.name = data.info.first_name + " " + data.info.last_name;
                state.credentials.qr = data.qr;
                state.credentials.timestamp = response.timestamp;
                state.credentials.username = data.info.username;
                state.credentials.tin = data.info.tin;
                state.credentials.hash = data.hash;
                state.credentials.gender = data.info.gender;
                state.credentials.has_pin = data.has_pin;
                state.credentials.deactivated = data.deactivated;
                const type2Config = data.config.find(item => item.type === 2);

                if (type2Config) {
                    state.credentials.config = { status: type2Config.status };
                } else {
                    state.credentials.config = null;
                }
                state.credentials.uuid = data.uuid;
                that.account_number = state.credentials.account_no;
                that.full_name = state.credentials.name;
                that.gender = state.credentials.gender;
                that.Astatus = state.credentials.status;
                that.Membership = state.credentials.membership_type;
                that.Member_since = state.credentials.membership_date;
                that.email = state.credentials.email;
                that.mobile = state.credentials.mobile;
                that.tin = state.credentials.tin;
                that.age = state.credentials.age;
                that.birthdate = state.credentials.birthdate;
                that.serial = state.credentials.serial_no == null ? '??????' : state.credentials.serial_no;
                that.username = state.credentials.username;
                that.registered = state.credentials.registered_date;
                that.qr = data.qr;
                that.currentTin = state.credentials.tin;
                that.express = data.express;
                that.deactivated = data.deactivated;
                const rawRegisteredDate = state.credentials.registered_date;
                if (rawRegisteredDate) {
                    const parts = rawRegisteredDate.split('-');
                    that.registered = `${parts[1]}/${parts[2]}/${parts[0]}`;
                }

                const rawBirthdate = state.credentials.birthdate;
                if (rawBirthdate) {
                    const parts = rawBirthdate.split('-');
                    that.birthdate = `${parts[1]}/${parts[2]}/${parts[0]}`;
                }

                this.setLoading(false);

                if (data.express) {
                    that.showUpdateEmailView();
                }
                if (data.deactivated) {
                    that.showSecurity();
                }
                if (that.currentEmail || that.currentMobile) {
                    that.verify = false;
                }
            }).catch(function (error) {
                that.error = true;
                this.setLoading(false);
                that.show_message_modal = true;
                that.modal_message = error.response.data.message;
                if (error.response.status == 403) {
                    that.expired = true
                    that.modal_message = "Your session has expired. Please log in again";
                }
            });
        },
        submit() {
            let that = this;
            let store = that.$store;
            let state = store.state;
            const cookie = that.$cookies;
            if (!that.expired) {
                if (that.error || that.success) {
                    if (that.updateType == 5) {
                        cookie.remove('user');
                        that.$router.push('/');
                    }
                    that.show_message_modal = false;
                } else {
                    if (that.updateType == 1) {
                        that.updateUsername();
                    }
                    if (that.updateType == 2) {
                        that.requestUpdateOtp();
                    }
                    if (that.updateType == 3) {
                        that.requestUpdateOtp();
                    }
                    if (that.updateType == 4) {
                        that.updatePassword();
                    }
                    // if(that.updateType == 5){
                    //     that.deactivateAccount();
                    // }
                    if (that.updateType == 6) {
                        that.updateTin();
                    }
                }
            } else {
                if (that.expired) {
                    state.credentials.hash = '';
                    state.logged = false;
                    that.expired = false;
                    that.$cookies.remove('user');
                    that.$router.push('/')
                }
            }

        },
        logout() {
            this.loading = true;
        },
        donelogout() {
            this.loading = false;
        },
        closed_modal() {
            this.show_message_modal = false;
        },
        updateUsernameTrigger() {
            this.updateType = 1;
            this.modal_message = "Are you sure you want to update your username?";
            this.warning = true;
            this.error = false;
            this.success = false;
            this.show_message_modal = true;
        },
        updateEmailTrigger() {
            this.otpType = '6';
            this.updateType = 2;
            this.modal_message = "Are you sure you want to update your email?";
            this.warning = true;
            this.error = false;
            this.success = false;
            this.show_message_modal = true;
        },
        updateMobileTrigger() {
            this.otpType = '7';
            this.updateType = 3;
            this.modal_message = "Are you sure you want to update your mobile?";
            this.warning = true;
            this.error = false;
            this.success = false;
            this.show_message_modal = true;
        },
        updateTinTrigger() {
            this.updateType = 6;
            this.modal_message = "Are you sure you want to update your TIN?";
            this.warning = true;
            this.error = false;
            this.success = false;
            this.show_message_modal = true;
        },
        updatePasswordTrigger() {
            this.updateType = 4;
            this.modal_message = "Are you sure you want to update your password?";
            this.warning = true;
            this.error = false;
            this.success = false;
            this.show_message_modal = true;
        },
        showUpdateUsernameView() {
            if (this.showUpdateUsername == false) {
                this.showUpdateUsername = true;
                this.showUpdateEmail = false;
                this.showUpdateMobile = false;
                this.showPasswordUpdateView = false;
                this.showSecurityView = false;
                this.showUpdateTin = false;
            }
        },
        showUpdateEmailView() {
            if (this.showUpdateEmail == false) {
                this.showUpdateEmail = true;
                this.showUpdateUsername = false;
                this.showUpdateMobile = false;
                this.showPasswordUpdateView = false;
                this.showSecurityView = false;
                this.showUpdateTin = false;
            }
        },
        updateUsername() {
            const that = this;
            const cookie = that.$cookies;
            var payload = {
                hash: cookie.get('user').hash,
                value: that.username,
            }
            this.setLoading(true);
            that.currentUsername = '';
            that.show_message_modal = false;
            User.editUserName(cookie.get('user').uuid, payload).then(function () {
                that.success = true;
                that.warning = false;
                that.error = false;
                that.modal_message = "Congratulations you have successfully updated your username.";
                that.show_message_modal = true;
                that.checkExistingCookie();
            }).catch(function (error) {
                if (error.response.status == 403) {
                    that.expired = true;
                    that.modal_message = "Your session has expired. Please log in again";
                    that.$store.state.logged = false;
                } else {
                    that.modal_message = error.response.data.message;
                }
                that.error = true;
                that.warning = false;
                that.success = false;
                this.setLoading(false);
                that.show_message_modal = true;
            });
        },
        updateTin() {
            const that = this;
            const cookie = that.$cookies;
            let tin = that.tin.replace('-', '')
            let tin1 = tin.charAt(0) + tin.charAt(1) + tin.charAt(2);
            let tin2 = tin.charAt(3) + tin.charAt(4) + tin.charAt(5);
            let tin3 = tin.charAt(6) + tin.charAt(7) + tin.charAt(8);

            this.setLoading(true);
            that.currentTin = '';
            that.show_message_modal = false;

            User.updateTin(cookie.get('user').uuid, tin1, tin2, tin3).then(function () {
                that.success = true;
                that.warning = false;
                that.error = false;
                that.modal_message = "Congratulations you have successfully updated your TIN.";
                that.show_message_modal = true;
                that.checkExistingCookie();
            }).catch(function (error) {
                if (error.response.status == 403) {
                    that.expired = true;
                    that.modal_message = "Your session has expired. Please log in again";
                    that.$store.state.logged = false;
                } else {
                    that.modal_message = error.response.data.message;
                }
                that.error = true;
                that.warning = false;
                that.success = false;
                this.setLoading(false);
                that.show_message_modal = true;
            });
        },
        updateEmail() {
            const that = this;
            const cookie = that.$cookies;
            var payload = {
                hash: cookie.get('user').hash,
                value: that.email,
            }
            this.setLoading(true);
            that.currentEmail = '';
            that.show_message_modal = false;
            User.editEmail(cookie.get('user').uuid, payload).then(function () {
                that.success = true;
                that.warning = false;
                that.error = false;
                that.modal_message = "Congratulations you have successfully updated your email.";
                that.show_message_modal = true;
                that.checkExistingCookie();
            }).catch(function (error) {
                that.error = true;
                that.warning = false;
                that.success = false;
                this.setLoading(false);
                that.show_message_modal = true;
                that.modal_message = error.response.data.message;
            });
        },
        updateMobile() {
            const that = this;
            const cookie = that.$cookies;

            var payload = {
                hash: cookie.get('user').hash,
                value: '+63' + that.mobile_number,
            }
            this.setLoading(true);
            that.currentMobile = '';
            that.show_message_modal = false;
            User.editMobile(cookie.get('user').uuid, payload).then(function () {
                that.success = true;
                that.warning = false;
                that.error = false;
                that.modal_message = "Congratulations you have successfully updated your mobile number.";
                that.show_message_modal = true;
                that.checkExistingCookie();
            }).catch(function (error) {
                that.error = true;
                that.warning = false;
                that.success = false;
                this.setLoading(false);
                that.show_message_modal = true;
                that.modal_message = error.response.data.message;
            });
        },
        updatePassword() {
            const that = this;
            const cookie = that.$cookies;

            var validationPayload = {
                hash: cookie.get('user').hash,
                password: that.old_password
            }
            this.setLoading(true);
            that.show_message_modal = false;
            User.validatePassword(validationPayload, cookie.get('user').uuid).then(function () {
                var updatingPasswordPayload = {
                    old_password: that.old_password,
                    new_password: that.new_password,
                    con_password: that.con_password,
                }
                User.updatePassword(updatingPasswordPayload, cookie.get('user').uuid).then(function () {
                    that.success = true;
                    that.warning = false;
                    that.error = false;
                    that.modal_message = "Congratulations you have successfully updated your password.";
                    that.show_message_modal = true;
                    that.checkExistingCookie();
                }).catch(function (error) {
                    if (error.response.status == 403) {
                        that.expired = true;
                        that.modal_message = "Your session has expired. Please log in again";
                        that.$store.state.logged = false;
                    } else {
                        that.modal_message = error.response.data.message;
                    }
                    that.error = true;
                    that.warning = false;
                    that.success = false;
                    this.setLoading(false);
                    that.show_message_modal = true;
                });
            }).catch(function (error) {
                if (error.response.status == 403) {
                    that.expired = true;
                    that.$store.state.logged = false;
                    that.modal_message = "Your session has expired. Please log in again";
                } else {
                    that.modal_message = error.response.data.message;
                }
                that.error = true;
                that.warning = false;
                that.success = false;
                this.setLoading(false);
                that.show_message_modal = true;
            });
        },
        showUpdateMobileView() {
            if (this.showUpdateMobile == false) {
                this.showUpdateMobile = true;
                this.showUpdateUsername = false;
                this.showUpdateEmail = false;
                this.showPasswordUpdateView = false;
                this.showSecurityView = false;
                this.showUpdateTin = false;
            }
        },
        showUpdatePasswordView() {
            if (this.showPasswordUpdateView == false) {
                this.showPasswordUpdateView = true;
                this.showUpdateMobile = false;
                this.showUpdateUsername = false;
                this.showUpdateEmail = false;
                this.showSecurityView = false;
                this.showUpdateTin = false;
            }
        },
        showUpdateTinView() {
            if (this.showUpdateTin == false) {
                this.showUpdateTin = true;
                this.showPasswordUpdateView = false;
                this.showUpdateMobile = false;
                this.showUpdateUsername = false;
                this.showUpdateEmail = false;
                this.showSecurityView = false;
            }
        },
        showSecurity() {
            if (this.showSecurityView == false) {
                this.showUpdateMobile = false;
                this.showUpdateUsername = false;
                this.showUpdateEmail = false;
                this.showPasswordUpdateView = false;
                this.showSecurityView = true;
                this.showUpdateTin = false;
            }
        },
        showAccountView() {
            if (this.showAccountInfoView == false) {
                this.showPasswordUpdateView = false;
                this.showAccountInfoView = true;
                this.showSecurityView = false;
                this.showPasswordUpdateView = false;
                this.showSecurityView = false;
                this.showUpdateTin = false;
            }
        },
        showMenu() {
            if (this.show_menu) {
                this.hideMenu();
            } else {
                this.show_menu = true;
            }
        },
        hideMenu() {
            this.show_menu = false;
        },
        changed(e) {
            let key = e.key;
            let that = this;
            that[key] = e.value;
            if (key == 'mobile_number') {
                that.checkChange({ value: e.value, type: 1 });
            }
            if (key == 'email') {
                that.checkChange({ value: e.value, type: 2 });
            }
        },
        checkChange(e) {
            if (e.type == 1) {
                if (e.value != this.currentMobile) {
                    this.enableMobile = true;
                } else {
                    this.enableMobile = false;
                }
            }
            if (e.type == 2) {
                if (e.value != this.currentEmail) {
                    this.enableEmail = true;
                } else {
                    this.enableEmail = false;
                }
            }
        },

        otpUpdate(e) {
            let that = this;
            that.otp = e.value;
        },
        downloadQR() {
            let url = this.getQr();
            axios.get(url, { responseType: 'blob' })
                .then(response => {
                    const blob = new Blob([response.data], { type: 'image/png' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = 'QR';
                    link.click();
                    URL.revokeObjectURL(link.href);
                })
        },
        resendOtp() {
            let that = this;
            this.setLoading(true);
            that.show_resend_otp = false;
            that.timerEnabled = true;
            that.timerCount = 120;
            let payload;
            if (that.otpType == '6') {
                payload = {
                    type: that.otpType,
                    email: that.currentEmail,
                    name: that.full_name,
                    pin: that.pin,
                }
            }
            if (that.otpType == '7') {
                payload = {
                    type: that.otpType,
                    mobile: that.currentMobile,
                    name: that.full_name,
                    pin: that.pin,
                }
            }
            OTP.requestOtp(payload).then(function (response) {
                that.pin = response.data.data.pin;
                this.setLoading(false);
                that.show_otp_modal = true;
            }).catch(function () {
                this.setLoading(false);
            });
        },
        requestUpdateOtp() {
            var payload = {}
            const that = this;
            that.show_message_modal = false;
            that.show_resend_otp = false;
            that.timerEnabled = true;
            that.timerCount = 120;

            if (that.otpType == '6') {
                payload = {
                    type: that.otpType,
                    email: that.currentEmail,
                    name: that.full_name,
                }
            }
            if (that.otpType == '7') {
                payload = {
                    type: that.otpType,
                    mobile: that.currentMobile,
                    name: that.full_name,
                }
            }
            this.setLoading(true);
            OTP.requestOtp(payload).then(function () {
                this.setLoading(false);
                that.show_otp_modal = true;
            }).catch(function (error) {
                if (error.response.status == 403) {
                    that.expired = true;
                    that.$store.state.logged = false;
                    that.modal_message = "Your session has expired. Please log in again";
                } else {
                    that.modal_message = error.response.data.message;
                }
                that.error = true;
                that.warning = false;
                that.success = false;
                this.setLoading(false);
                that.show_message_modal = true;
            });
        },
        submitOtp() {
            let that = this;
            this.setLoading(true);
            let payload;
            if (that.otpType == '6') {
                payload = {
                    otp: that.otp,
                    type: that.otpType,
                    email: that.currentEmail,
                }
            }
            if (that.otpType == '7') {
                payload = {
                    otp: that.otp,
                    type: that.otpType,
                    mobile: that.currentMobile,
                }
            }
            this.setLoading(true);
            OTP.validate(payload).then(function () {
                that.show_otp_modal = false;
                that.otp = '';
                if (that.otpType == '6') {
                    that.updateEmail();
                }
                if (that.otpType == '7') {
                    that.updateMobile();
                }
            }).catch(function (error) {
                that.error = true;
                this.setLoading(false);
                that.show_message_modal = true;
                that.modal_message = error.response.data.message;
            });
        },
        getQr() {
            let that = this;
            return "https://quickchart.io/qr?text=" + that.qr;
        },
    },
    watcher: {
        timerCount: {
            handler(value) {
                if (value > 0 && this.timerEnabled) {
                    this.show_resend_otp = false;
                    setTimeout(() => {
                        this.timerCount = this.timerCount - 1;
                        // console.log(this.timerCount);
                    }, 1000);
                } else {
                    this.show_resend_otp = true;
                    this.timerEnabled = false; // run your function here
                }
            },
            immediate: true
        },
    }
})
</script>
<style scoped>
.max-width-back {
    max-width: 50px;
}
</style>
